export default __webpack_public_path__ + "static/media/cavinimg.c5616e26.jpg";